import React from 'react';

interface CommonHeaderProps {
    title: string;
    buttonText?: string;
    onButtonClick?: () => void;
}

const CommonHeader: React.FC<CommonHeaderProps> = ({ title, buttonText, onButtonClick }) => {
    return (
        <header className="bg-ez-surface border-b border-ez-border h-12 px-6 flex justify-between items-center shadow-sm">
            <h1 className="text-lg font-semibold text-ez-text-primary">
                {title}
            </h1>
            {buttonText && onButtonClick && (
                <button
                    onClick={onButtonClick}
                    className="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-md text-sm font-medium shadow-sm transition-colors duration-150"
                >
                    {buttonText}
                </button>
            )}
        </header>
    );
};

export default CommonHeader;
